import { render, staticRenderFns } from "./ViewPrivateMessage.vue?vue&type=template&id=b92ce024&"
import script from "./ViewPrivateMessage.vue?vue&type=script&lang=js&"
export * from "./ViewPrivateMessage.vue?vue&type=script&lang=js&"
import style0 from "./ViewPrivateMessage.vue?vue&type=style&index=0&id=b92ce024&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports